const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-year',
        label: '연도',
        value: 'year',
        query: {'y': 'year'},
        options: {
          default: '',
          useAll: true,
        }
      },
      {
        'component': 'search-month',
        label: '월',
        value: 'month',
        query: {'m': 'month'},
        options: {
          default: '',
          lastLabel: true,
          useAll: true,
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['대상연월', '작성일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.year || search.month) {
      let yearMonth = "";
      if (search.year) {
        yearMonth += `${search.year}년 `;
      }
      if (search.month) {
        yearMonth += `${search.month > 9 ? search.month : '0'+search.month}월`;
      }

      conditions.push({key: 'body.headerDateString', operator: 'LIKE', value: `%${yearMonth}%`})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "대상연월",
        "key": "body.headerDateString"
      },
      {
        "name": "소속명",
        "key": "body.stdInfo.department"
      },
      {
        "name": "부서명",
        "key": "body.stdInfo.section"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      },
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 사업장명
        case 1: return func.getContent(value).headerDateString // 대상연월
        case 2: return func.getContent(value).stdInfo.department // 소속명
        case 3: return func.getContent(value).stdInfo.section // 부서명
        case 4: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
